module.exports = __webpack_public_path__ + "static/media/UNC.94f3eb81.svg";